<template>
  <div>
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>预定服务总览</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="table">
      <el-row>
 
          <!-- 广告申请 -->
        <el-col :span="24">

          <el-card class="box-card">
            <div slot="header" class="clearfix"><span>广告申请</span></div>
            <div class="itembox" v-if="!isPC">
              <ul class="supitem" v-for="(item, index) in adTableData" :key="index">
                <li>
                  <span>名称：</span>
                  <span>{{item.srjName}}</span>
                </li>
                <li>
                  <span>规格：</span>
                  <span>{{item.srjScale}}</span>
                </li>
                <li>
                  <span>单价(RMB)：</span>
                  <span>{{item.srjSalePrice}}</span>
                </li>
                <li>
                  <span>单位：</span>
                  <span>{{item.srjUnit}}</span>
                </li>
                <li>
                  <span>数量：</span>
                  <span>{{item.oddTotalNum}}</span>
                </li>
                <li>
                  <span>小计：</span>
                  <span>{{ getFixed(item,'ad') }}</span>
                </li>
              </ul>
              <div class="total"><strong>费用总计：{{adData[0].price}}</strong></div>
            </div>
            <div v-else>
                <el-table :data="adTableData" style="width: 100%" border>
                  <el-table-column prop="srjName" label="名称" align='center' width="300"></el-table-column>
                  <el-table-column prop="srjScale" label="规格" align='center'></el-table-column>
                  <el-table-column prop="srjSalePrice" label="单价(RMB)" align='center' width="200"></el-table-column>
                  <el-table-column prop="srjUnit" label="单位" align='center' width="120" ></el-table-column>
                  <el-table-column  prop="oddTotalNum" label="数量" align='center'  width="120"></el-table-column>
                  <el-table-column label="小计" align='center'><template slot-scope="scope">{{  getFixed(scope.row,'ad') }}</template></el-table-column>
                </el-table>
          
              <el-table :data="adData" style="width: 100%" border :show-header='false' :cell-style="cellStyle" >
                <el-table-column align='center' width="300"><template slot-scope="scope">{{ scope.row.text}}</template></el-table-column>
                <el-table-column  align='center'><template  slot-scope="scope">{{scope.row.price}}</template></el-table-column>
              </el-table>
            </div>
          </el-card>

          <!-- 用电申请 -->
          <el-card class="box-card">  
            <div slot="header" class="clearfix"><span>用电申请</span></div>

         
            <div class="itembox" v-if="!isPC">
              <ul class="supitem" v-for="(item, index) in electTableData" :key="index">
                <li>
                  <span>名称：</span>
                  <span>{{item.srjName}}</span>
                </li>
                <li>
                  <span>规格：</span>
                  <span>{{item.srjScale}}</span>
                </li>
                <li>
                  <span>单价(RMB)：</span>
                  <span>{{item.srjSalePrice}}</span>
                </li>
                <li>
                  <span>押金(RMB)：</span>
                  <span>{{item.srjBrand}}</span>
                </li>
                <li>
                  <span>数量：</span>
                  <span>{{item.oddTotalNum}}</span>
                </li>
                <li>
                  <span>小计：</span>
                  <span>{{ getFixed(item,'elect') }}</span>
                </li>
              </ul>
              <div class="total"><strong>费用总计：{{electData[0].price}}</strong></div>
            </div>
            <div v-else>
              <el-table :data="electTableData" style="width: 100%" border>
                <el-table-column prop="srjName" label="名称" align='center' width="300"></el-table-column>
                <el-table-column prop="srjScale" label="规格" align='center'></el-table-column>
                <el-table-column prop="srjSalePrice" label="单价(RMB)" align='center' width="200"></el-table-column>
                <el-table-column prop="srjBrand" label="押金(RMB)" align='center' width="120" ></el-table-column>
                <el-table-column prop="oddTotalNum"  label="数量" align='center'  width="120"></el-table-column>
                <el-table-column label="小计" align='center'>
                    <template slot-scope="scope">{{ getFixed(scope.row,'elect')}}</template>
                </el-table-column>
              </el-table>
              <el-table :data="electData" style="width: 100%" border :show-header='false' :cell-style="cellStyle" >
                <el-table-column align='center' width="300"><template slot-scope="scope">{{ scope.row.text}}</template></el-table-column>
                <el-table-column  align='center'><template  slot-scope="scope">{{scope.row.price}}</template></el-table-column>
              </el-table>
            </div>
          </el-card>

            <!-- 展具租赁 -->
          <el-card class="box-card">
            <div slot="header" class="clearfix"><span>展具租赁</span></div>
 
         
            <div class="itembox" v-if="!isPC">
              <ul class="supitem" v-for="(item, index) in exhibitionTableData" :key="index">
                <li>
                  <span>名称：</span>
                  <span>{{item.srjName}}</span>
                </li>
                <li>
                  <span>规格：</span>
                  <span>{{item.srjScale}}</span>
                </li>
                <li>
                  <span>预订租价(RMB)：</span>
                  <span>{{item.srjBuyPrice}}</span>
                </li>
                <li>
                  <span>现场租价(RMB)：</span>
                  <span>{{item.srjSalePrice}}</span>
                </li>
                <li>
                  <span>押金(RMB)：</span>
                  <span>{{item.srjBrand}}</span>
                </li>
                <li>
                  <span>数量：</span>
                  <span>{{item.oddTotalNum}}</span>
                </li>
                <li>
                  <span>小计：</span>
                  <span>{{ getFixed(item,'exhibit') }}</span>
                </li>
              </ul>
              <div class="total"><strong>费用总计：{{exhibitionData[0].price}}</strong></div>
            </div>
            <div v-else>
              <el-table :data="exhibitionTableData" style="width: 100%" border>
                  <el-table-column prop="srjName" label="名称" align='center' width="300"></el-table-column>
                  <el-table-column prop="srjScale" label="规格" align='center'></el-table-column>
                  <el-table-column prop="srjBuyPrice" label="预订租价(RMB)" align='center' width="200"></el-table-column>
                  <el-table-column prop="srjSalePrice" label="现场租价(RMB)" align='center' width="120" ></el-table-column>
                  <el-table-column prop="srjBrand" label="押金(RMB)" align='center' width="120" ></el-table-column>
                  <el-table-column prop="oddTotalNum" label="数量" align='center'  width="120"></el-table-column>
                  <el-table-column label="小计" align='center'>
                      <template slot-scope="scope">{{ getFixed(scope.row,'exhibit') }}</template>
                  </el-table-column>
                </el-table>

                <el-table :data="exhibitionData" style="width: 100%" border :show-header='false' :cell-style="cellStyle" >
                  <el-table-column align='center' width="300"><template slot-scope="scope">{{ scope.row.text}}</template></el-table-column>
                  <el-table-column  align='center'><template  slot-scope="scope">{{scope.row.price}}</template></el-table-column>
                </el-table>
            </div>
          </el-card>

          <div class="allPrice">总价：{{allPrice}}</div>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<script>
import api from '@/api'
import tools from '../utils/tools.js';
export default {
  data: () => ({
      adTableData: [],  //广告申请数据
      electTableData: [],  //用电申请数据
      exhibitionTableData: [],  //广告申请数据
      adData:[{text:"费用合计：",price:0}],
      electData:[{text:"费用合计：",price:0}],
      exhibitionData:[{text:"费用合计：",price:0}],
      allPrice:0,
      isPC: true
  }),

  components: {},
  mounted() {
    this.isPC = tools.isPC()
    api.getservicebooklist({
      typeName:'广告申请',
      isReservation:true
    }).then((res) => {              
        if(res.data.code == '200'){
            var _data = res.data.data.list
            this.adTableData = [..._data];
            this.getTotalPrice("ad")
        }
    })

    api.getservicebooklist({
      typeName:'用电申请',
      isReservation:true
    }).then((res) => {              
        if(res.data.code == '200'){
            var _data = res.data.data.list
            this.electTableData = [..._data];
            this.getTotalPrice("elect")
        }
    })

    api.getservicebooklist({
      typeName:'展具租赁',
      isReservation:true
    }).then((res) => {              
        if(res.data.code == '200'){
            var _data = res.data.data.list
            this.exhibitionTableData = [..._data];
            this.getTotalPrice("exhibition")
        }
    })

  },
  methods: {
    getFixed(val,str){
      if(str == 'ad'){
          return  parseFloat( val.oddTotalNum * val.srjSalePrice).toFixed( 2 ) 
      }else if(str == 'elect'){
          return  parseFloat( val.oddTotalNum * (val.srjSalePrice + val.srjBrand)).toFixed( 2 ) 
      }else if(str == 'exhibit'){
          return  parseFloat( val.oddTotalNum * (val.srjSalePrice + val.srjBrand + val.srjBuyPrice)).toFixed( 2 ) 
      }else {
        return 0
      }
      
    },

    cellStyle(row,column,rowIndex,columnIndex){
        return ' background: #f5f7fa;color:#000;fontWeight:bold'    
    },
    getTotalPrice(str){
      let _price =0;
      var _list = this[str+"TableData"]
      if( _list.length>0){
          for(var i=0;i< _list.length;i++){
            if(str == 'ad'){
                _price +=  _list[i].oddTotalNum * parseFloat( _list[i].srjSalePrice) ;
            }
            if(str == 'elect'){
                _price += _list[i].oddTotalNum * parseFloat( (_list[i].srjSalePrice + _list[i].srjBrand ) ).toFixed( 2 ) 
            }
            if(str == 'exhibition'){
                _price += _list[i].oddTotalNum *  parseFloat( (_list[i].srjSalePrice + _list[i].srjBuyPrice + _list[i].srjBrand )).toFixed( 2 ) 
            }
          }
   
          this[str+"Data"][0].price =  parseFloat( _price ).toFixed( 2 )
   
          this.allPrice += _price 
      }

    },


  }
}
</script>
<style lang="less">
.table{
  margin:20px 0
}

.box-card{
  margin-bottom: 30px;
}

.allPrice{
  padding:10px 0;
  text-align: right;
  font-size: 18px;
}
.el-card__header span{
  font-size:14px
}
@media screen and (max-width:540px){
  .itembox{
    font-size:14px;
    line-height: 2;
    .supitem{
      border-bottom: 1px solid #eee;
    }
    .total{
      background: rgb(245, 247, 250);
      columns: #000000;
      padding: 10px;
      margin-top:10px
    }
  }
}
</style>

